module.exports = __webpack_public_path__ + "static/img/circuits.e29226bb.png";